import styled from 'styled-components'

export const DrawerWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: white;
  height: 100%;
  overflow-y: auto;
  .drawer-divider {
    width: 100%;
    height: 1px;
    background: #efefef;
    margin: 0;
    flex: 1 0 1px;
  }
`
